import { useCreatePath, useRecordContext } from 'react-admin';
import { useRegisterBreadcrumb } from '../layout/navbar/BreadcrumbsManager';
import resourceNames from '../../constants/resourceNames';

const MemberBreadcrumb = () => {
  const record = useRecordContext();
  const createPath = useCreatePath();
  const path = createPath({ resource: resourceNames.MEMBERS, type: 'edit', id: record?.id });
  useRegisterBreadcrumb({
    title: record ? `${record.firstName} ${record.lastName}` : '',
    path,
  });

  return null;
};

export default MemberBreadcrumb;
